import {
    AutoHeightContainer,
    FileView,
    usePageSearch,
    useTherapproveModals
} from "@therapprove/common";
import { FileHeader } from "./FileHeader";
import { useFileFilters } from "./useFileFilters";

export const Files = () => {
    // State
    const { search, setSearch, debouncedSearch } = usePageSearch();
    const { fileUpload } = useTherapproveModals();
    const { filters, setFilters } = useFileFilters();

    return (
        <AutoHeightContainer style={{ gap: "1rem" }}>
            <FileHeader
                search={search}
                setSearch={setSearch}
                filters={filters}
                setFilters={setFilters}
                onUpload={() => fileUpload.open()}
            />
            <FileView
                search={debouncedSearch}
                fileTypes={filters.fileTypes}
            />
        </AutoHeightContainer>
    );
};
